import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-bottom-toolbar',
  templateUrl: './bottom-toolbar.component.html',
  styleUrls: ['./bottom-toolbar.component.scss']
})
export class BottomToolbarComponent implements OnInit {
  public isClients: boolean;
  public isSnapshots: boolean;

  @Input() fileCounter: number;
  @Input() activeFileCounter: number;

  @Input()
  set state(state: string) {
    this.isClients = state === 'clients';
    this.isSnapshots = state === 'snapshots';
  }

  @Output() download = new EventEmitter<void>();
  @Output() info = new EventEmitter<void>();
  @Output() zero = new EventEmitter<void>();
  @Output() rename = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();

  constructor() { }

  ngOnInit() { }

  public handleAction(action: string): void {
    this[action].emit();
  }
}
